import axios from "axios";

export const HTTP_ERROR_MESSAGES: Record<number, string> = {
  401: "Session expired. Please log in again.",
  403: "You don't have permission to access this resource.",
  404: "The requested resource was not found.",
  429: "Too many requests. Please try again later.",
  500: "Something went wrong on our end.",
  501: "This feature is not yet supported.",
  502: "Server received an invalid response.",
  503: "Service is currently unavailable.",
  529: "The server is currently unable to handle the request due to high traffic. Please try again later."
};

export const NETWORK_ERROR_MESSAGES: Record<string, string> = {
  "Network Error": "Unable to connect. Please check your internet connection.",
  "timeout exceeded": "Request timed out. Please try again later.",
};

export const FALLBACK_ERROR = "An unexpected error occurred. Please try again.";




export const getToastMessage = (error: unknown): string => {
  if (axios.isAxiosError(error)) {
    // ✅ Get status directly from error object — no need to pass it
    const status = error?.response?.status;
    const data = error?.response?.data;

    const apiMessage =
      typeof data === "object" && data !== null
        ? data?.message || data?.error || data?.title
        : null;

    const statusText = error?.response?.statusText?.trim() || null;

    return (
        error.message ||
      apiMessage                       ||
      statusText                       ||
    
      (status ? HTTP_ERROR_MESSAGES[status] : null) ||
      "An unexpected error occurred."
    );
  }

  if (error instanceof Error) {
    return NETWORK_ERROR_MESSAGES[error.message] || "An unexpected error occurred.";
  }

  return "An unexpected error occurred.";
};